// Helper functions for marking page dirty, used to warn user before switching organisation
export const setPageDirtyFlag = (value) => {
  if(value) {
    if(!pageIsDirty()) {
      localStorage.setItem("pageDirty", "true") 
    }
  } else {
    if(pageIsDirty()) {
      localStorage.removeItem("pageDirty")
    }
  }
}

export const pageIsDirty = () => {
  return localStorage.getItem("pageDirty") === "true";
}